import { render, staticRenderFns } from "./baseBreadCrumb.vue?vue&type=template&id=167b7e6a&scoped=true"
import script from "./baseBreadCrumb.vue?vue&type=script&lang=js"
export * from "./baseBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./baseBreadCrumb.vue?vue&type=style&index=0&id=167b7e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b7e6a",
  null
  
)

export default component.exports